import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import 'gw-portals-util-js/FunUtil';
import { PhoneNumberUtil } from 'libphonenumber';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import nameUtil from 'edge/gateway/util/NameUtil';
import moment from 'moment';

var fn = function fn($translate, $state, $rootScope, $scope, $q, $stateParams, AccountService, PolicyService, ActivityService, $modal, $window, ModalService, $filter, UserService, TranslateService, defaultLocaleDetails) {
    var ctrl = Object.create(BaseCtrl);

    var phoneUtils = PhoneNumberUtil.getInstance();
    /**
     * Method to initialize the call to get recently viewed policies details and initialize the scope variable
     * Get MSF portal host and assign that to loss run link
     * @return ("host name of the Loss run ")
     */
    ctrl.init = function () {
        $rootScope.selectedTermNumber = null;
        addRecentlyViewedPolicies();
        initialiseScopeVariables();
        $scope.msfHost = PolicyService.getMsfPortalHost();
        $scope.msfHost.then(function (data) {
            $scope.MSFLossrunLink = data;
        }, function (err) {
            console.error('Error while retrieving MSF host: ', err);
        });

        /**
         * Service call to get policy details for the specified policy number which is taken from the URL
         * display policy details if policy number exist, if not display relevant error message
         * @param ("policyNumber", "policy number which has been initiated from Portal")
         * @return ("policyDTO", Object) contains all policy and account related details
         */
        var policyRequest = PolicyService.getPolicy($stateParams.policyNumber);
        policyRequest.then(function (policy) {
            if (!policy.policyNumber) {
                ModalService.showError('policy.viewinformation.You may not have access to view this policy.Please contact Montana State Fund at 1-800-332-6102 or email stfpolicy@mt.gov for assistance.');
                $state.go('policies.index');
            }

            $scope.policy = policy;
            $scope.accountInfo = {};
            $scope.latestPeriod = policy.latestPeriod;
            //$scope.latestActivePeriod = policy.latestActivePeriod;

            $scope.product = policy.product;
            // Execute the main method
            mapAccountDetails(policy.account);
            $scope.latestPeriod.expirationDate = policy.latestPeriod.expirationDate;
            $scope.oscPolicyExists = policy.latestPeriod.oscPolicyExists;
            $scope.team = policy.latestPeriod.team;

            var cancellationDate = moment($scope.latestPeriod.expirationDate);
            var currentDate = PolicyService.getCurrentDate();
            currentDate.then(function (res) {
                var splitedCurrentDate = res.match(/(\d+)/g);

                $scope.subtractedDate = new Date(splitedCurrentDate[0], splitedCurrentDate[1] - 1, splitedCurrentDate[2] - 5, splitedCurrentDate[3], splitedCurrentDate[4], splitedCurrentDate[5]);
                var thirtyDaysBack = $scope.subtractedDate;
                // show reinstatement button only 30 days before from the cancellation effective date
                $scope.showRequestReinstatementButton = moment(thirtyDaysBack).isBefore(cancellationDate);
            });
        }, function () {
            var msg = $translate('gateway.views.policy-detail.findPolicy.nopolicy', { policyNumber: $stateParams.policyNumber });
            ModalService.showError('gateway.views.modal.Error', msg);
            $state.go('policies.index');
        });

        /**
         * method to get billing summary details for particular policy Number  
         * execute the main method       
         */
        var billingPromise = getPolicyBillingSummary($scope.policyNumber);
        billingPromise.then(function (policyBillingSummary) {
            $scope.policyBillingSummary = policyBillingSummary;
            if (angular.isDefined($scope.policyBillingSummary.policyPeriodBillingSummaries)) {
                if ($scope.policyBillingSummary.policyPeriodBillingSummaries[0].isDelinquent) {
                    $scope.billingIcon = 'icon-error fa-exclamation-triangle';
                }
            }
        }, function () {});
        /**
         * To make policy summary page to load faster
         */
        $scope.policyLoadedPromise = $q.all([policyRequest]);
    };

    /**
     * function to initialize the scope variables for policy transaction table config and activity table config
     * configuring meta data template for document
     */
    function initialiseScopeVariables() {
        $scope.billingFeatureTurnedOn = ApplicationFeatures.getAllFeatures().gatewayBilling === 'true';

        $scope.policyTransactionTableConfig = {
            transactionStatus: '',
            policyTransactionStatus: [],
            source: 'account',
            search: ''
        };
        // execute the main method
        getPolicyTransactionStatus();

        $scope.activityTableConfig = {
            actStatus: 'allOpen',
            defaultActStatus: 'allOpen',
            actStatusOptions: {
                'allOpen': 'gateway.directives.ActivitySummary.All Open',
                'allClosed': 'gateway.directives.ActivitySummary.All Closed',
                'overdue': 'gateway.directives.ActivitySummary.Overdue',
                'openAssignedToMe': 'gateway.directives.ActivitySummary.Open, Assigned to me'
            },
            showAddActivity: false
        };

        $scope.documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'letter_received',
            securityType: 'unrestricted',
            status: 'approved',
            policyNumber: $stateParams.policyNumber
        };

        $scope.policyNumber = $stateParams.policyNumber;
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
        $scope.changeFormIsVisible = false;
        $scope.renewFormIsVisible = false;

        var applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.enableClaims = applicationFeatures.gatewayclaims === 'true';

        $scope.billingIcon = 'gw-icon-done fa-check';
    }
    /**
     * Main function that gets called to get status of the policy transaction
     * assigning values and display key for the status, 
     * By default assigning the status as Draft for the policy transaction
     */
    function getPolicyTransactionStatus() {
        var status = [{
            value: 'all',
            name: '',
            displayKey: 'gateway.views.account-detail.All'
        }, {
            value: 'Draft',
            name: '',
            displayKey: 'typekey.PolicyPeriodStatus.Draft'
        }];
        // Execute the main method
        $scope.policyTransactionTableConfig.policyTransactionStatus = translatePolicyTransactionStatuses(status);
        $scope.policyTransactionTableConfig.transactionStatus = status[1];
    }
    /**
     * Main function that gets called to translate the policy transaction status
     * @param ("statuses", "all and draft status are passing")
     * @return ("statuses", "translated the statuses using TranslateService and return the statuses")
     */
    function translatePolicyTransactionStatuses(statuses) {
        statuses.forEach(function (status) {
            TranslateService.translate({
                object: status,
                propName: 'name',
                displayKey: status.displayKey,
                scope: $scope
            });
        });

        return statuses;
    }

    /**
     * Main method that gets called to get the policy billing summary info for the particular policy number 
     * @param ("policyNumber","policy number which has been initiated from Portal") 
     * @return ("PolicyBillingSummaryDTO" Object) DTO contains all billing details for the given policy number
     */
    function getPolicyBillingSummary(policyNumber) {
        return PolicyService.getPolicyBillingSummaryInfo(policyNumber);
    }

    /**
     * Method to map the account details which is associated with the policy and assign it to account info scope object
     * @param ("accountDetails", "account details for the given policy")
     * @return {void} assigning account details id, account number and policy details to accountInfo object
     */
    function mapAccountDetails(accountDetails) {
        if (!accountDetails) {
            return;
        }

        $scope.accountInfo.publicID = accountDetails.publicID;
        $scope.accountInfo.policySummaries = accountDetails.policySummaries;
        $scope.accountInfo.accountNumber = accountDetails.accountNumber;
        $scope.accountInfo.canCreateSub = accountDetails.canUserCreateSubmission;
        // Execute main method
        setupAccountContactDetails(accountDetails.accountHolder);
    }

    /**
     * Main method that gets called to setting up account contact details by checking the account holder sub type and primary phone type
     * @param ("accountHolder", "details of the account holder")
     * @return {void}
     */
    function setupAccountContactDetails(accountHolder) {
        $scope.accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            $scope.accountInfo.firstName = accountHolder.firstName;
            $scope.accountInfo.lastName = accountHolder.lastName;
            $scope.accountInfo.contactName = nameUtil.getDisplayName(accountHolder, ' ');
        } else {
            $scope.accountInfo.contactName = accountHolder.contactName;
        }

        $scope.accountInfo.primaryAddress = accountHolder.primaryAddress;

        if (accountHolder.primaryPhoneType === 'work' && angular.isDefined(accountHolder.workNumber) && accountHolder.workNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.workNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'home' && angular.isDefined(accountHolder.homeNumber) && accountHolder.homeNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.homeNumber, defaultLocaleDetails.countryCode));
        } else if (accountHolder.primaryPhoneType === 'mobile' && angular.isDefined(accountHolder.cellNumber) && accountHolder.cellNumber.length > 0) {
            $scope.accountInfo.primaryPhoneNumber = phoneUtils.format(phoneUtils.parse(accountHolder.cellNumber, defaultLocaleDetails.countryCode));
        }
    }

    ctrl.showAddActivity = function () {
        $scope.activityTableConfig.showAddActivity = true;
    };

    /**
     * Method to get the boolean value of the activity from the service call
     * Used to display the activity button based on the boolean result
     * @param ("permissionDTO", "actcreate permission has been passed to hasUserSystemPermission service call")
     * @return ("showAddActivityButton", "based on the response assigning boolean value to scope object") 
     */
    ctrl.shouldShowAddActivityButton = function () {
        var permissionDTO = {
            permission: 'actcreate'
        };

        var actPromise = UserService.hasUserSystemPermission(permissionDTO);

        actPromise.then(function (showActivity) {
            $scope.showAddActivityButton = showActivity;
        });
    };

    ctrl.shouldShowAddActivityButton();

    ctrl.goBackOne = function () {
        window.history.back();
    };
    /**
     * Function to show cancellation form
     * set true to cancelFormIsVisible to display the cancellation form
     */
    ctrl.showCancellationForm = function () {
        $scope.formIsOpen = true;
        $scope.cancelFormIsVisible = true;
    };

    /**
     * Method to hide cancellation form by assigning false value to scope object
     */
    ctrl.hideCancellationForm = function () {
        $scope.formIsOpen = false;
        $scope.cancelFormIsVisible = false;
    };

    /**
     * Method to show change form by assigning true boolean value to scope object
     */
    ctrl.showChangeForm = function () {
        $scope.formIsOpen = true;
        $scope.changeFormIsVisible = true;
    };

    /**
     * Method to hide change form by assigning false boolean value to scope object
     */
    ctrl.hideChangeForm = function () {
        $scope.formIsOpen = false;
        $scope.changeFormIsVisible = false;
    };

    /**
     * Method to show Renew form by assigning true boolean value to scope object
     */
    ctrl.showRenewForm = function () {
        $scope.formIsOpen = true;
        $scope.renewFormIsVisible = true;
    };

    /**
     * Method to hide Renew form by assigning false boolean value to scope object
     */
    ctrl.hideRenewForm = function () {
        $scope.formIsOpen = false;
        $scope.renewFormIsVisible = false;
    };

    ctrl.policyContactTileIsActive = function () {
        return $state.includes('policies.detail.contacts') || $state.includes('policies.detail.contact-detail') || $state.includes('policies.detail.associated-contact-detail') || $state.includes('policies.detail.account-contact-detail');
    };

    /**
     * Method to update recently viewed policies details for the given policy number
     * @param ("policyNumber", "policy number which has been initiated from portal")
     * @return (void) update viewed date if the policy has been viewed recently
     */
    function addRecentlyViewedPolicies() {
        PolicyService.addRecentlyViewedPolicy($stateParams.policyNumber);
    }

    /**
     * Service call to get details of documents such as account number, policy number, job number, level and canDelete for the given policy
     * @param ("policyNumber","policyNumber which has been initiated from portal") 
     * @return ("documentDTO","Object") 
     * get the length of the document and assign that to docLength scope variable
     */
    PolicyService.getDocumentsForPolicy($stateParams.policyNumber).then(function (data) {
        $scope.docLength = data.length;
        if ($scope.docLength === -1) {
            $scope.docLength = 0;
        }
    }, function () {});

    /**
     * Event listener to set the number of open activities 
     * checking the open status condition for openActivities and assigning the length of the open activities to policy's number of activities
     */
    $scope.$on('activitiesUpdated', function (event, data) {
        if (angular.isDefined($scope.policy)) {
            var openActivities = _.where(data, {
                status: 'open'
            });
            if (openActivities.length !== $scope.policy.numberOfOpenActivities) {
                $scope.policy.numberOfOpenActivities = openActivities.length; // Set the number of open activities
            }
        }
    });

    /**
     * Event listener to set the number of notes 
     * assigning the length of the notes to policy's number of notes
     */
    $scope.$on('notesUpdated', function (event, data) {
        if (angular.isDefined($scope.policy)) {
            $scope.policy.numberOfNotes = data.length;
        }
    });

    /**
     * Event listener to increase the number notes when adding the new notes 
     * 
     */
    $scope.$on('noteAdded', function () {
        if (angular.isDefined($scope.policy)) {
            $scope.policy.numberOfNotes++;
        }
    });

    /**
     * Event listener to set the number of documents 
     * assigning the length of the documents to policy's number of documents
     */
    $scope.$on('documentsUpdated', function (event, data) {
        if (angular.isDefined($scope.policy)) {
            $scope.policy.numberOfDocuments = data.length;
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$translate', '$state', '$rootScope', '$scope', '$q', '$stateParams', 'AccountService', 'PolicyService', 'ActivityService', '$modal', '$window', 'ModalService', '$filter', 'UserService', 'TranslateService', 'defaultLocaleDetails'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/PolicyDetailCtrl.js
// module id = 1680
// module chunks = 0